hasMemo